import { Component, Vue } from 'vue-property-decorator'
import CAHG1140Service from './CAHG1140Service'
import CAHG1140ViewModel from './CAHG1140ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import CommonConstants from '@/common/CommonConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent, fixedContentNoLogin } from '@/assets/js/main.js'

@Component({
  name: 'CAHA1140',
  components: {}
  })
export default class CAHG1140Controller extends Vue {
  private cahg1140ViewModel: CAHG1140ViewModel = {
    simulatAttnContHtmlInfo: {
      content: ''
    },
    batchDispDiv: ''
  }

  private XSSFilterOptions = XSSFilterOptions
  private cahg1140Service: CAHG1140Service = new CAHG1140Service()

  /**
   * 画面要素描画後処理
   */
  mounted() {
    fixedContent()
    fixedContentNoLogin()
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const caha1140ResponseModel = await this.cahg1140Service.callAPICAHA1140()

    if (CommonUtil.isNotEmpty(caha1140ResponseModel.simulatAttnContHtmlInfo)) {
      this.cahg1140ViewModel.simulatAttnContHtmlInfo.content =
        CommonUtil.replacePathCMS(
          caha1140ResponseModel.simulatAttnContHtmlInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caha1140ResponseModel.simulatAttnContHtmlInfo.path
        )
    } else {
      this.cahg1140ViewModel.simulatAttnContHtmlInfo = null
    }
    this.cahg1140ViewModel.batchDispDiv = caha1140ResponseModel.batchDispDiv
  }

  /**
   * シミュレーションTOPへ戻るリンク押下
   */
  private backSimulationTop(nameScreen: string) {
    this.$router.push({ name: nameScreen })
  }
}
